export default __webpack_public_path__ + "_privacy-policy.html";